import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as button from '../../../../../button'
import * as overlay from '../../../../../overlay'
import * as text from '../../../../text'
import { AtnDsSelectSingleEcStore } from '../../store'

@ngCore.Component({
  imports: [button.Component, text.Component, overlay.centered.Component],
  selector: 'atn-ds-custom-label-dialog',
  standalone: true,
  styleUrl: './custom-label-dialog.component.scss',
  templateUrl: './custom-label-dialog.component.html',
})
export class CustomLabelDialogComponent<
  TTypeParams extends ec.models.TypeParams.Constraint,
> {
  /** @see {@link AtnDsSelectSingleEcStore<TTypeParams>} */
  public readonly store = ngCore.inject<AtnDsSelectSingleEcStore<TTypeParams>>(
    AtnDsSelectSingleEcStore,
  )

  /** TODO:  */
  public saveBtnClickHandler(): void {
    this.store.submitCustomLabel()
  }
  /** TODO:  */
  public cancelOrCloseBtnClickHandler(source: 'close' | 'cancel'): void {
    if (source === 'close') {
      this.store.closeCustomEdit()
    } else {
      this.store.cancelCustomEdit()
    }
  }
  /** TODO:  */
  public labelChangedHandler(label: string): void {
    this.store.editCustomLabel(label)
  }
}
